module.exports = __webpack_public_path__ + "static/img/640047B_C_1_2_3_4_20180418_LC.0741cff.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/640047B_C_1_2_3_4_20180418_LC.png
// module id = s51p
// module chunks = 0